import TrustUpIOTask from "@spa/apps/trustup-pro-base-js/models/TrustUpIOTask";

export default class WorksitePhaseTrustUpIOTask extends TrustUpIOTask
{

    static getComponentPrefix()
    {
        return 'worksite:worksite-phase-trustup-io-task';
    }
    
}